import React from 'react';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Download the Planner',
    desc: 'Get instant access to the digital PDF immediately after purchase. Accessible on phone, tablet, or desktop.'
  }, {
    num: '02',
    title: 'Follow the 48-Hour Clock',
    desc: 'Execute the meal and liquid timings precisely. The schedule tells you exactly what to consume and when.'
  }, {
    num: '03',
    title: 'Wake Up Light',
    desc: 'Face your event with a flat stomach, peak confidence, and zero digestive discomfort.'
  }];
  return <section className="py-24 bg-white" data-id="element-106">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107">
        <div className="text-center mb-16" data-id="element-108">
          <h2 className="text-3xl md:text-4xl font-serif text-stone-900 mb-4" data-id="element-109">
            How It Works
          </h2>
          <p className="text-lg text-stone-600" data-id="element-110">
            Three simple steps to execute the reset.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-111">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-px bg-stone-200 z-0" data-id="element-112"></div>

          {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center group" data-id="element-113">
              <div className="w-24 h-24 bg-white rounded-full border-4 border-stone-50 shadow-sm flex items-center justify-center mb-6 group-hover:border-forest-100 transition-colors duration-300" data-id="element-114">
                <span className="text-3xl font-serif text-forest-800" data-id="element-115">
                  {step.num}
                </span>
              </div>
              <h3 className="text-xl font-medium text-stone-900 mb-3" data-id="element-116">
                {step.title}
              </h3>
              <p className="text-stone-600 leading-relaxed px-4" data-id="element-117">{step.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}